module.exports = __webpack_public_path__ + "4a4b3b4409122d4399100d7f9833e228.jpg";